import styled from 'styled-components';
import { motion } from 'framer-motion';
import { GREEN_COLOR } from '../constants';

export const Section = styled(motion.section)`
  width: 100vw;
  padding: 8rem 0;
  background-color: ${(props) => props.backgroundColor || '#fff'};
  overflow-x: hidden;
  @media (max-width: 768px) {
    padding: 4rem 0;
  }
`;

export const SectionContent = styled.div`
  max-width: 1320px;
  margin: 0 auto;
  width: 100%;
  padding: 0 2rem;
  box-sizing: border-box;
  @media (max-width: 768px) {
    padding: 0 1.5rem;
  }
`;

export const SectionTitle = styled(motion.h2)`
  font-size: 2.5rem;
  font-weight: 700;
  color: #1f2937;
  margin-top: 0.5rem;
  text-align: left;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-bottom: 0px;
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const SectionSubtitle = styled(motion.p)`
  font-size: 16px;
  font-weight: 700;
  color: white;
  margin-bottom: 0;
  text-align: left;
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const SectionDescription = styled(motion.p)`
  font-size: 1.25rem;
  color: #000;
  text-align: left;
  margin: 0 0 4rem 0;
  line-height: 1.6;
  max-width: 800px;
  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

export const WhatWeDoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-bottom: 4rem;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const WhatWeDoItem = styled(motion.div)`
  position: relative;
  height: 300px;
  border-radius: 16px;
  overflow: hidden;
  transition: transform 0.3s;
  &:hover {
    transform: translateY(-5px);
  }
  @media (max-width: 768px) {
    height: 250px;
  }
`;

export const WhatWeDoImage = styled.div`
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const WhatWeDoTextOverlay = styled.div`
  background: linear-gradient(rgba(0, 0, 0, 0.5), transparent);
  color: #fff;
  padding: 1rem;
  font-size: 1.1rem;
  font-weight: 600;
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const WhyPlayfair = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  margin-bottom: 4rem;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const WhyItem = styled(motion.div)`
  background: white;
  padding: 3rem;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  text-align: center;
  transition: transform 0.3s;
  &:hover {
    transform: translateY(-5px);
  }
  @media (max-width: 768px) {
    padding: 2rem;
  }
`;

export const WhyIcon = styled.div`
  color: ${GREEN_COLOR};
  font-size: 3rem;
  margin-bottom: 1rem;
`;

export const WhyTitle = styled.h3`
  font-size: 1.8rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 1rem;
`;

export const WhyText = styled.p`
  color: #6b7280;
  font-size: 1.1rem;
`;

export const TestimonialItem = styled(motion.div)`
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  border-left: 4px solid white;
  width: 380px;
  flex-shrink: 0;
  margin-right: 2rem;

  @media (max-width: 768px) {
    width: 300px;
  }
`;

export const TestimonialQuote = styled.p`
  font-style: italic;
  color: #1f2937;
  margin-bottom: 1rem;
`;

export const TestimonialAuthor = styled.p`
  font-weight: 600;
  color: #1f2937;
`;

export const StarRating = styled.div`
  display: flex;
  gap: 0.25rem;
  margin-bottom: 1rem;
`;
